import { render, staticRenderFns } from "./MenuAccount.vue?vue&type=template&id=666d974e&"
import script from "./MenuAccount.vue?vue&type=script&lang=js&"
export * from "./MenuAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports